import React from "react";

function Footer() {
  return (
    <footer>
      <ul>
        <li>
          <a href="https://github.com/marisela-gutierrez" target="_blank" rel="noreferrer">Github</a>
        </li>
        <li>
          <a href="https://linkedin.com/in/mariselagutierrez" target="_blank" rel="noreferrer">LinkedIn</a>
        </li>
      </ul>
    </footer>
  );
}

export default Footer;